
import React from 'react';

const TruckUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<path
				fill='#2d2d2d'
				d='M43.7 19.35l-6.195-8.25a1.52 1.52 0 00-1.2-.6H29V6c0-.825-.675-1.5-1.5-1.5h-21C5.675 4.5 5 5.175 5 6v22.5c0 .825.675 1.5 1.5 1.5h3.075c.375 2.535 2.535 4.5 5.175 4.5 2.64 0 4.8-1.965 5.175-4.5h10.65c.375 2.535 2.535 4.5 5.175 4.5 2.64 0 4.8-1.965 5.175-4.5H42.5c.825 0 1.5-.675 1.5-1.5v-8.25c0-.33-.105-.645-.3-.9zM14.75 31.5a2.247 2.247 0 01-2.25-2.25A2.247 2.247 0 0114.75 27 2.247 2.247 0 0117 29.25a2.247 2.247 0 01-2.25 2.25zm0-7.5c-2.085 0-3.87 1.23-4.725 3H8V7.5h18V27h-6.525c-.855-1.77-2.64-3-4.725-3zm21 7.5a2.247 2.247 0 01-2.25-2.25A2.247 2.247 0 0135.75 27 2.247 2.247 0 0138 29.25a2.247 2.247 0 01-2.25 2.25zM41 27h-.525c-.84-1.77-2.64-3-4.725-3-2.085 0-3.87 1.23-4.725 3H29V13.5h6.555L38.93 18H30.5v3H41v6zM41 40.5H8v3h33v-3z'
			></path>
		</svg>
	);
};

export default TruckUnderline;
